import { useContext, onMounted, inject } from '@nuxtjs/composition-api';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import { getArticleCategoryPathNames } from '~/modules/article/utils/articleUtils';
import { SPONSORED } from '~/constants/config';
import { generateGA4Article } from '~/modules/tracking/scripts/dataLayer';

export function useArticle() {
  const { sendPageviewEvent, sendOnedioSRVHit, sendArticleRefTags, sendArticleHashtags } = useTracking();
  const { i18n } = useContext();

  /**
   * Send Page View
   * @param {Object} article
   * @param {Boolean} isLoggedIn
   * @param {Boolean} isSponsored
   */
  const sendPageView = (article, isLoggedIn = false, isSponsored = false) => {
    sendPageviewEvent(
      () => ({
        event: 'PageView',
        page: {
          name: article.value?.title || i18n.t('news-page.no-content'),
          type: 'Haber Detay',
        },
        content: {
          category1: article.value?.breadcrumb?.[0]?.name || '',
          category2: article.value?.breadcrumb?.[1]?.name || '',
          category3: article.value?.breadcrumb?.[2]?.name || '',
          name: article.value?.title || i18n.t('news-page.no-content'),
          id: article.value?.legacyId,
          editor: article.value?.authors?.[0]?.username || '~no-username',
          date: article.value?.dates?.published?.slice(0, 10),
          tags: article.value?.tags || [],
          refTags: article.value?.refTags?.map((v) => v.name),
          isSponsored: SPONSORED.some((i) => article.value?.tags?.includes(i)),
          isScrollToNext: 0,
          entryCount: article.value?.entries?.length,
          segments: article.value?.segmentsID || '',
          isSponsoredCategory: isSponsored ? 1 : 0,
          ...(getArticleCategoryPathNames(article.value)?.[1] && { subcategory1: getArticleCategoryPathNames(article.value)?.[1] }),
          ...(getArticleCategoryPathNames(article.value)?.[2] && { subcategory2: getArticleCategoryPathNames(article.value)?.[2] }),
        },
      }),
      [article],
      isLoggedIn
    );
    sendArticleRefTags(() => article.value?.refTags, [article]);
    sendArticleHashtags(() => article.value?.hashtags, [article]);
  };

  onMounted(() => {
    const article = inject('article');
    sendOnedioSRVHit(article);
    const adConfig = inject('adConfig');
    window.dataLayer.push({
      ecommerce: null,
    });
    window.dataLayer.push({
      event: 'view_item', // Sabit olarak bu değer yazılmalıdır.
      ecommerce: {
        items: [generateGA4Article({ article: article.value, adConfig })],
      },
    });
  });

  return { sendPageView };
}
